/*
 * address (schema)
 */
import { boolean, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { patients } from "../patient/patient.schema"
import { practitioners } from "../practitioner/practitioner.schema"
import { users } from "../user/user.schema"

export const addresses = schema.table("addresses", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	patientId: uuid("patient_id").references(() => patients.id, {
		onDelete: "cascade",
	}),
	practitionerId: uuid("practitioner_id").references(() => practitioners.id, {
		onDelete: "cascade",
	}),

	// --- General ---
	type: varchar("type", { length: 32 }).notNull().default("home"),
	line1: varchar("line1", { length: 256 }).notNull(),
	line2: varchar("line2", { length: 256 }),
	city: varchar("city", { length: 128 }).notNull(),
	state: varchar("state", { length: 128 }),
	postalCode: varchar("postal_code", { length: 32 }),
	country: varchar("country", { length: 64 }).notNull().default("US"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, {
		onDelete: "set null",
	}),
	updatedBy: uuid("updated_by").references(() => users.id, {
		onDelete: "set null",
	}),
})
